import "regenerator-runtime/runtime";
import $ from 'jquery';

import { toggleFavourites } from "./parts/add-to-favourites";
import { addToCart } from "./parts/add-to-cart";
import { bindCopy2Clipboard } from "./parts/clipboard";
import { bindPwdToggle } from "./parts/pwd-toggle";
import { addNotification } from "./parts/notifications";

import "./parts/prod-archive";
import "./parts/header";
import "./libs/animos";

import  "./parts/custom-select";


$(document).ready(() => {

    (function() {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let later = new Date();
        later.setTime(Date.now() + 30 * 24 * 60 * 60 * 1000);
        
        document.cookie ='time_zone='+ timezone +'; expires='+ later +'; path=/';
    })()

    $('.add-to-favourites').each((i, e) => {
        $(e).on('click', () => {
            toggleFavourites($(e));
        });
    });
    $('.add-to-cart').each((i, e) => {
        const $e = $(e);
        $e.on('click', (event) => {
            event.preventDefault();
            if ($e.hasClass('already-bought')) {
                if ($e.hasClass('did-accept-buy-again')) {
                    addToCart($e.data('id'));
                } else {
                    const $accept = $(`
                        <div class="buy-again">
                            <span>You already have this course, are you sure you want to buy it again?</span>
                            <span class="yes">Yes</span>
                            <span class="no">No</span>
                        </div>
                    `);
                    $accept.insertAfter($e);
                    $accept.find('.no').on('click', () => {
                        $accept.remove();
                    });
                    $accept.find('.yes').on('click', () => {
                        $e.addClass('did-accept-buy-again');
                        $accept.remove();
                        $e.click();
                    });
                }
            } else if ($e.hasClass('need-dependency')) {
                if ($e.hasClass('did-accept-dependency')) {
                    addToCart($e.data('id'));
                } else {
                    const $accept = $(`
                        <div class="dependency buy-again">
                            <span>It looks like you haven't completed part of the course yet, are you sure you want to continue?</span>
                            <span class="yes">Yes</span>
                            <span class="no">No</span>
                        </div>
                    `);
                    $accept.insertAfter($e);
                    $accept.find('.no').on('click', () => {
                        $accept.remove();
                    });
                    $accept.find('.yes').on('click', () => {
                        $e.addClass('did-accept-dependency');
                        $accept.remove();
                        $e.click();
                    });
                }
            } else {
                addToCart($e.data('id'));
            }
        });
    });


    //run collapse elements
    if($(".collapse").length){
        import('./parts/custom-collapse')
    }

    if ($('body').hasClass('single-course') || $('body').hasClass('single-webinar') ) {
        import('./parts/course')
        .then((module)=>{
            const course = new module.Course();
        });
    }
    
    if ($('body').hasClass('single-lesson')) {
        import('./parts/lesson')
        .then((module)=>{
            const course = new module.Lesson();
        });
        //Lesson();
        
    }

    if($("body").hasClass("single-webinar")){
        import('./parts/webinar')
        .then((module)=>{
            const webinar = new module.Webinar();
        });
    }

    if ($('body').hasClass('woocommerce-checkout')) {
        import('./parts/checkout');
    }
    
    if ($('body').hasClass('page-template-education-paths')) {
        import('./parts/education-paths');
    }

    if ($('body').hasClass('page-template-login')) {

        import('./parts/fb')
        .then((module)=>{
            module.initFacebook($('.login--hidden[data-fb]'), 'fb_login');
        })
        
        
    }

    if ($('body').hasClass('page-template-register')) {
        import('./parts/register');
    }


    if ($('body').hasClass('my-account-settings')) {
        import('./parts/my-account')
        .then((module)=>{
            module.handleAvatarEdit();
            module.bindRequiredSettings();
        })
    }

    if ($('body').hasClass('woocommerce-cart')) {
        import('./parts/cart')
        .then((module)=>{
            //module.bindTypeChange();
            module.bindPointsPurchase();
        })
      
    }

    if($("#quiz").length > 0){
        import('./parts/quiz');
    }
    
    if ($('body').hasClass('page-template-course-editor')) {
        import('./parts/course-editor')
        .then((module)=>{
            const editor = new module.CourseEditor();
        })
    }
  
    if ($('body').hasClass('page-template-webinar-editor')) {
        import('./parts/webinar-editor')
        .then((module)=>{
            const editor = new module.WebinarEditor();
        })
    }

    if($(".accordion").length){
        import('./parts/accordion');
    }

    if($('.atc-popup-button').length > 0){
        import('./parts/archives');
    }
 
    

    // $('.home-courses .level-select a').each((i, e) => {
    //     const $e = $(e);
    //     const type = ($e.attr('href').replace('#', ''));

    //     $e.on('click', () => {
    //         $('.home-courses .level-course').hide().filter('.' + type).show();
    //         $('.home-courses .level-select a').removeClass('is-active');
    //         $e.addClass('is-active');
    //     });
    // });

    if ($(".notify--timeout").length) {
        setTimeout(() => {
            $(".notify-container").fadeOut("fast");
        }, 2000)
    }

    $(".notify__close").on("click",function(){
        $(".notify-container").fadeOut("fast");
    })

    $('.copy-clipboard').each((i, e) => {
        bindCopy2Clipboard($(e));
    });

    $('.pwd-toggle').each((i, e) => {
        bindPwdToggle($(e));
    });

    if($(".education-path__timeline").length){
        let trueWidth = $(".education-path__timeline")[0].scrollWidth - 120;
        $(".education-path__timeline").attr("style", "--true-width:"+trueWidth+"px")
    }

    $(".anim-holder").on("click",function(e){
        $(this).find(".panel-full").show();
    })

    $("#search-icon").on("click",function(){
        $(this).parent().submit();
    })

});

$(".set-referral").on("click",function(){

    let pkey = $("#referral").val();
    if(pkey.slice(-1) == "/"){
        pkey = pkey.slice(0, -1);
    }

    //get the last part of the url
    pkey = pkey.split("/").pop();


    let later = new Date();
    later.setTime(Date.now() + 30 * 24 * 60 * 60 * 1000);
    document.cookie ='wps_wpr_cookie_set='+ pkey +'; expires='+ later +'; path=/';

    $(".reflink__note").html("Code Applied");


});

//on click of the button .newsletter-send , send the email #add-to-newsletter to the server with ajax
$(".newsletter-send").on("click",function(){
    let email = $("#add-to-newsletter").val();
    let name = $("#add-to-newsletter-name").val();
    //check if is correct email via regex
    let regex = /\S+@\S+\.\S+/;
    if(!regex.test(email)){
        addNotification("Please enter a valid email address","error");
        return;
    }
    $.ajax({
        url: tromplo.ajax_url,
        type: "POST",
        data: {
            action: "add_to_newsletter",
            footer_newsletter: email,
            footer_newsletter_name: name
        },
        success: function (response) {
            $(".newsletter__note").html(response);
            addNotification("You have been added to our newsletter");
            $("#add-to-newsletter").val("");
        },
        error: function (error) {
            addNotification("Something went wrong, please try again later","error");
        }
    });
});



//get .lightbox-wannabe url and create simple lightbox with it that will be destroyed on click
$("body").on("click",".lightbox-wannabe",function(){
    let img = $(this).attr("src");
    let lightbox = '<div class="lightbox"><img src="'+img+'"></div>';
    $("body").append(lightbox);
    $(".lightbox").on("click",function(){
        $(".lightbox").remove();
    })
});

$(".popup--header").on("click",function(){
    $(this).parent().toggleClass("inactive");
});

//if cookie newsletter-popup is not set, show the popup and create the cookie for 7 days
// if(!document.cookie.includes("newsletter_popup")){
//     $(".popup").removeClass("inactive");
//     let later = new Date();
//     later.setTime(Date.now() + 7 * 24 * 60 * 60 * 1000);
//     document.cookie ='newsletter_popup=true; expires='+ later +'; path=/';

// }

